import { defineMessage, useIntl } from 'react-intl';

import { css } from '@sorare/css';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconSearch } from '#src/atoms/icons/system/iconSearch.ts';
import { TextInput } from '#src/atoms/inputs/TextInput/index.tsx';
import { useShortcutWithKeys } from '#src/hooks/useShortcutWithKeys.tsx';
import { useToggle } from '#src/hooks/useToggle.ts';

import { SearchBarDialog } from './SearchBarDialog/index.tsx';

const dialogTrigger = css`
  &,
  & * {
    text-align: left;
    cursor: pointer;
  }
`;

const placeholder = defineMessage({
  defaultMessage: 'Search...',
});

export const SearchBar = () => {
  const { formatMessage } = useIntl();
  const [searchDialogOpened, toggleSearchDialogOpened] = useToggle(false);

  const { Icon: searchShortcut } = useShortcutWithKeys(
    'cmdk',
    () => {
      toggleSearchDialogOpened();
    },
    [toggleSearchDialogOpened]
  );

  return (
    <>
      <TextInput
        className={dialogTrigger}
        type="button"
        onClick={toggleSearchDialogOpened}
        startAdornment={
          <FontAwesomeIcon icon={iconSearch} color="var(--c-nd-600)" />
        }
        value={formatMessage(placeholder)}
        endAdornment={searchShortcut}
      />
      <SearchBarDialog
        open={!!searchDialogOpened}
        onClose={() => toggleSearchDialogOpened()}
      />
    </>
  );
};
